import { SalesChannelCategoryGroupUpdatePage } from "@/features/sales-channel-category-group/pages/SalesChannelCategoryGroupUpdatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/admin/sales-channel-category-group/$id/update",
)({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: ["sales_channel_category_groups.edit"],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: SalesChannelCategoryGroupUpdatePage,
});
